// extracted by mini-css-extract-plugin
export default {"image":"style_image__a1dRg","image_sm":"style_image_sm__Q3uFB"};